export const generateAssetTitle = (title: string, postalCode: string): string => {
  if (!title && !postalCode) return '';
  if (title && postalCode) return `${title} • ${postalCode}`;
  if (!postalCode) return title;
  if (!title) return postalCode;
};
